import { TruncatedTextWithTooltip } from '@app/components/base/TruncatedTextWithTooltip';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { ReportResultProps } from '../../../../../../../../core/reports/types';
import { SchedulesMentionsIndexListing } from './MentionsIndexView';

export const SchedulesListMentionsIndexResult = (
  p: ReportResultProps<SchedulesMentionsIndexListing>,
) => {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={p.result.results}
      enableTopToolbar={false}
      columns={[
        {
          header: $t({
            id: 'audit.props.mentionId',
            defaultMessage: 'ID mention',
          }),
          size: 100,
          accessorKey: 'customId',
        },
        {
          header: $t({
            id: 'common.text.count',
            defaultMessage: 'Cantidad',
          }),
          size: 70,
          accessorKey: 'count',
          enableColumnFilter: false,
        },
        {
          header: $t({
            id: 'common.text.description',
            defaultMessage: 'Descripción',
          }),
          size: 120,
          accessorKey: 'name',
        },
        {
          header: $t({
            id: 'common.text.content',
            defaultMessage: 'Contenido',
          }),
          accessorKey: 'original',
          filterFn: 'contains',
          Cell: ({ row }) => (
            <TruncatedTextWithTooltip value={row.original.original} length={100} />
          ),
        },
      ]}
    />
  );
};
